import { ArticleType } from '../../../domain/articleType';
import { buildArticlesURLObject, buildArticleURLObject } from './articles';
import { QueryObject } from './common';

export interface BuildNewsURLObject {
  id: string,
  slug: string,
  [key: string]: string,
}

export function buildNewsSerpURLObject(query: QueryObject = {}) {
  return buildArticlesURLObject(query, ArticleType.NEWS);
}

export function buildNewsURLObject(
  urlObject: BuildNewsURLObject,
) {
  return buildArticleURLObject(urlObject, ArticleType.NEWS);
}
